import type { RootState } from "Data/Store/Store";
import { useDispatch, useSelector } from "react-redux";
import { useCallback } from "react";
import {
  UnauthorizedPopupState,
} from "@model/Authentication.model";
import { showUnauthorizedPopupAction } from "./ShowUnauthorizedPopupAction";
import { clearUnauthorizedPopupAction } from "./ClearUnauthorizedPopupAction";

const unauthorizedPopupSelector = (state: RootState) =>
  state.unauthorizedPopupReducer;

export const UnauthorizedPopupStoreImplementation = () => {
  const dispatch = useDispatch();
  const popupState = useSelector<RootState, UnauthorizedPopupState>(
    unauthorizedPopupSelector
  );

  const showPopup = useCallback(
    (message: string) => showUnauthorizedPopupAction(message)(dispatch),
    [dispatch]
  );

  const clearPopup = useCallback(
    () => clearUnauthorizedPopupAction()(dispatch),
    [dispatch]
  );

  return {
    popupState,
    showPopup,
    clearPopup,
  };
};
